module.exports = __webpack_public_path__ + "static/2-31af846176bf285e7479e8e37f11c48e.jpg";